(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('Invoices', Invoices);

  function Invoices($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoices/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());
